import {
  formatPurchasePlanningCashRequired,
  formatPurchasePlanningNumber,
  formatPurchasePlanningPercent,
  getContainerOptimizationGroupBadgeClass,
  getContainerOptimizationGroupStatusLabel,
} from '../../../lib/purchasePlanningHelpers';

export function ContainerOptimizationMainTable({ groups, selectedGroupId, onSelectGroup }) {
  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
      <div className="max-h-[calc(100vh-18rem)] overflow-auto">
        <table className="min-w-full text-left text-sm">
          <thead className="sticky top-0 z-10 bg-slate-50 text-xs uppercase tracking-[0.12em] text-gray-500">
            <tr>
              <th className="px-4 py-3 font-medium">Supplier</th>
              <th className="px-4 py-3 font-medium">Container group</th>
              <th className="px-4 py-3 text-right font-medium">SKUs</th>
              <th className="px-4 py-3 text-right font-medium">Group base buy</th>
              <th className="px-4 py-3 text-right font-medium">Fill units</th>
              <th className="px-4 py-3 text-right font-medium">Containers</th>
              <th className="px-4 py-3 text-right font-medium">Container units</th>
              <th className="px-4 py-3 text-right font-medium">Pre-fill util.</th>
              <th className="px-4 py-3 text-right font-medium">Adjusted group units</th>
              <th className="px-4 py-3 text-right font-medium">Cash required</th>
              <th className="px-4 py-3 font-medium">Status</th>
            </tr>
          </thead>
          <tbody>
            {groups.length > 0 ? (
              groups.map(group => (
                <tr
                  key={group.id}
                  className={`cursor-pointer border-b border-gray-100 hover:bg-gray-50 ${
                    selectedGroupId === group.id ? 'bg-slate-50/80' : ''
                  }`}
                  onClick={() => onSelectGroup?.(group.id)}
                >
                  <td className="px-4 py-3 align-top text-gray-600">{group.supplier}</td>
                  <td className="px-4 py-3 align-top text-gray-600">
                    <p className="font-medium text-gray-900">{group.containerGroup}</p>
                    <p className="mt-1 text-xs text-gray-500">
                      {group.months.join(', ') || 'Unscheduled'}
                    </p>
                  </td>
                  <td className="px-4 py-3 text-right align-top tabular-nums text-gray-900">
                    {formatPurchasePlanningNumber(group.skuCount)}
                  </td>
                  <td className="px-4 py-3 text-right align-top tabular-nums text-gray-900">
                    {formatPurchasePlanningNumber(group.groupBaseBuy)}
                  </td>
                  <td className="px-4 py-3 text-right align-top tabular-nums font-medium text-gray-900">
                    {formatPurchasePlanningNumber(group.fillUnits)}
                  </td>
                  <td className="px-4 py-3 text-right align-top tabular-nums text-gray-900">
                    {formatPurchasePlanningNumber(group.containers)}
                  </td>
                  <td className="px-4 py-3 text-right align-top tabular-nums text-gray-900">
                    {formatPurchasePlanningNumber(group.containerUnits)}
                  </td>
                  <td className="px-4 py-3 text-right align-top tabular-nums text-gray-900">
                    {formatPurchasePlanningPercent(group.preFillUtilization)}
                  </td>
                  <td className="px-4 py-3 text-right align-top tabular-nums font-semibold text-gray-900">
                    {formatPurchasePlanningNumber(group.adjustedGroupUnits)}
                  </td>
                  <td className="px-4 py-3 text-right align-top tabular-nums text-gray-900">
                    {formatPurchasePlanningCashRequired(group.totalCashRequired)}
                  </td>
                  <td className="px-4 py-3 align-top">
                    <span
                      className={`inline-flex rounded-md px-2 py-1 text-[11px] font-medium ${getContainerOptimizationGroupBadgeClass(group)}`}
                    >
                      {getContainerOptimizationGroupStatusLabel(group)}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="px-4 py-8 text-sm text-gray-500" colSpan={11}>
                  No container-optimization groups match the current filters.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
